import brokenImg from "@/assets/fatal_error4.svg";
import { Icon } from "@/assets/icons";
import notfoundImg from "@/assets/page_not_found3.svg";
import { ROUTES } from "@/constants/routes";
import { AxiosError } from "axios";
import React from "react";
import { useNavigate } from "react-router-dom";
import { unknown } from "zod";
import { Button } from "../Button";

type State = {
  hasError: boolean;
  error?: Error;
};

// HOC để inject navigate
function withNavigate(Component: any) {
  return function WrappedComponent(props: any) {
    const navigate = useNavigate();
    return <Component {...props} navigate={navigate} />;
  };
}

class ErrorBoundaryClass extends React.Component<
  { children: React.ReactNode; navigate: (path: string) => void },
  State
> {
  constructor(props: {
    children: React.ReactNode;
    navigate: (path: string) => void;
  }) {
    super(props);
    this.state = { hasError: false };
  }

  // static getDerivedStateFromError(error: Error) {
  //   // Cập nhật state để render fallback UI
  //   return { hasError: true, error };
  // }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);

    // If status code is 401, reload the page to redirect to login
    if (error.message.includes("401")) {
      this.props.navigate(ROUTES.LOGIN);
    }

    // If status code is 404 , navigate to not found page
    if (error.message.includes("404")) {
      this.props.navigate(ROUTES.ERROR_404);
    }

    // If status code is 500 , navigate to error page
    if (error.message.includes("500")) {
      this.props.navigate(ROUTES.ERROR_500);
    }

    return this.setState({ hasError: true, error });
  }

  // Reset error state
  resetError = () => {
    // this.setState({ hasError: false, error: undefined });

    // reset page
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError && this.state.error) {
      const error = this.state.error;
      let message = error.message;
      let statusCode: number | unknown = unknown;

      // Check axios error
      if (error.name === "AxiosError") {
        message =
          (error as AxiosError<{ message: string }>).response?.data?.message ||
          message;

        statusCode = (error as AxiosError).status;
      }

      return (
        <div className="flex flex-col items-center gap-2 justify-center h-full">
          <img
            src={statusCode === 404 ? notfoundImg : brokenImg}
            alt="500page"
            width={320}
          />
          <div className="text-cyan text-3xl-plus font-bold text-center truncate max-w-[90%]">
            {message || error.name}
          </div>
          {/* <div className="text-cyan text-lg leading-160% font-bold">
            {message}
          </div> */}

          {/* {process.env.NODE_ENV === "development" && (
            <div className="text-light_secondary leading-160% font-noto-sans text-xs lg:max-w-3xl text-center">
              {error.stack}
            </div>
          )} */}

          <Button
            type="button"
            variant="solid"
            color="primary"
            iconLeft={<Icon name="home" />}
            className="!h-12 mt-4"
            onClick={this.resetError}
          >
            トップページへ
          </Button>
        </div>
      );
    }

    return this.props.children;
  }
}

export const ErrorBoundary = withNavigate(ErrorBoundaryClass);
